import API from "@aws-amplify/api";
import { Device, Emicon } from "../../types/Device";

async function handleAnlagenStatusNew(currentDevice: Emicon | Device, isEmicon: boolean, statusVal: string) {

  try {
    const { serialNumber } = currentDevice || {};

    const dateNow = Math.round(Date.now() / 1000)

    const startOfDayTimestamp = Math.floor(new Date(dateNow * 1000).setHours(0, 0, 0, 0) / 1000);

    // Add 14 days in seconds
    const FOURTEEN_DAYS_IN_SECONDS = 14 * 24 * 60 * 60;
    const endOfFourteenthDay = Math.floor(new Date((startOfDayTimestamp + FOURTEEN_DAYS_IN_SECONDS) * 1000).setHours(23, 59, 59, 999) / 1000);

    await API.post('emilog', 'updateInfos', {
      body: {
        serialNumber,
        isEmicon,
        fields: { AnlagenStatus: statusVal, AnlagenStatusEnde: statusVal === 'Abgeschlossen' ? 0 : endOfFourteenthDay },
      },
    });
  } catch (err) {
    console.log(err);
  }
}

export default handleAnlagenStatusNew;
